import { throwApiError } from 'src/packages/errors';

import type { AxiosInstance } from 'axios';

export class RefreshKeyCloakUsersAndGroupsApi {
  private readonly agent: AxiosInstance;

  constructor(agent: AxiosInstance) {
    this.agent = agent;
  }

  refreshKeyCloakUsersAndGroups = async () => {
    try {
      await this.agent.post('/golibrary/api/v2/keycloak/groups/sync');
    } catch (error) {
      throwApiError(error);
    }
  };
}
